import type { IPreviewerProps } from 'dumi';
import { useTabMeta } from 'dumi';
import React from 'react';

import CodePreviewer from './CodePreviewer';
import DesignPreviewer from './DesignPreviewer';

export interface AntdPreviewerProps extends IPreviewerProps {
  originDebug?: IPreviewerProps['debug'];
  jsx?: string;
}

const Previewer: React.FC<AntdPreviewerProps> = (props) => {
  const tab = useTabMeta();

  if (tab?.frontmatter.title === 'Design') {
    return <DesignPreviewer {...props} />;
  }

  return <CodePreviewer {...props} />;
};

export default Previewer;
